import { render } from "./LoadingScreenComponent.vue?vue&type=template&id=4bc4c451&scoped=true"
import script from "./LoadingScreenComponent.vue?vue&type=script&lang=js"
export * from "./LoadingScreenComponent.vue?vue&type=script&lang=js"

import "./LoadingScreenComponent.vue?vue&type=style&index=0&id=4bc4c451&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc4c451"]])

export default __exports__